import {observer} from 'mobx-react';
import {ScheduleDetails, Employees, Review} from './components';

const Steps = observer(({step, uiState}) => {
  switch (step) {
    case 'schedule_details':
      return <ScheduleDetails uiState={uiState}/>;
    case 'employees':
      return <Employees uiState={uiState}/>;
    case 'review':
      return <Review uiState={uiState}/>;
    default:
      throw new Error(`Location ${step} is not supported.`);
  }
});

export default Steps;
